// src/pages/legal/Cookies.js
import React from 'react';

const Cookies = () => {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Politique des cookies</h1>
        <p className="text-gray-500 mb-8">Dernière mise à jour : 15 Juin 2024</p>
        
        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-3">Qu'est-ce qu'un cookie ?</h2>
            <p className="text-gray-600">Un cookie est un petit fichier texte déposé sur votre ordinateur, tablette ou smartphone lors de la visite d'un site web. Il permet de reconnaître votre appareil et de mémoriser certaines informations.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Cookies utilisés</h2>
            <p className="text-gray-600">Nous utilisons des cookies essentiels au fonctionnement du site (panier, authentification), des cookies de mesure d'audience (Google Analytics) pour améliorer nos services, et des cookies de préférences pour mémoriser vos choix.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Durée de conservation</h2>
            <p className="text-gray-600">Les cookies ont une durée de vie maximale de 13 mois, conformément à la réglementation. Passé ce délai, votre consentement est à nouveau demandé.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Gestion des cookies</h2>
            <p className="text-gray-600">Vous pouvez à tout moment modifier votre consentement via notre gestionnaire de cookies. Vous pouvez également configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site pourraient être altérées.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Cookies tiers</h2>
            <p className="text-gray-600">Nous utilisons Stripe pour les paiements et Google Analytics pour l'analyse d'audience. Ces services peuvent déposer leurs propres cookies. Nous vous invitons à consulter leurs politiques respectives.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Cookies;